<template>
    <Transition
        v-if="showNotification && show"
        enter="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterFrom="translate-y-0 opacity-100 sm:translate-x-0"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
    >
        <div class="fixed bottom-0 left-0 right-0 z-30 flex items-start justify-center px-4 py-6 pointer-events-none sm:p-6">
            <div class="w-full max-w-sm rounded-lg shadow-lg pointer-events-auto tier-3-bg">
                <div class="overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <svg
                                    data-description="danger"
                                    class="w-5 h-5 danger-svg-text"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div class="ms-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium leading-5 tier-3-text">
                                    {{ message }}
                                </p>
                            </div>

                            <div class="flex shrink-0 ms-4">
                                <tertiary-button
                                    @click="show = false"
                                    class="inline-flex transition duration-150 ease-in-out"
                                >
                                    <svg
                                        data-description="close"
                                        class="w-5 h-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </tertiary-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script>
import TertiaryButton from '@/components/ui/UiTertiaryButton.vue';
export default {
    name: 'thing-error-notification',
    components: {
        TertiaryButton,
    },
    props: {
        message: {
            default: '',
        },
        showNotification: {
            default: false,
        },
    },
    data() {
        return {
            show: true,
        };
    },
};
</script>
